import { arcToCubic } from "./arcToCubic.ts";
import { quadToCubic } from "./quadToCubic.ts";
import { lineToCubic } from "./lineToCubic.ts";
import type { CSegment, MSegment, PathSegment } from "../types.ts";
import type { ParserParams } from "../interface.ts";

/**
 * Converts any segment to C (cubic-bezier).
 *
 * @param segment the source segment
 * @param params the source segment parameters
 * @returns the cubic-bezier segment
 */
export const segmentToCubic = (
  segment: PathSegment,
  params: ParserParams,
): MSegment | CSegment => {
  const pathCommand = segment[0];
  const values = segment.slice(1).map(Number);
  const [x, y] = values;
  // let args;
  // const { x1: px1, y1: py1, x: px, y: py } = params;
  const { x1: px1, y1: py1 } = params;

  if (!"TQ".includes(pathCommand)) {
    params.qx = null;
    params.qy = null;
  }

  if (pathCommand === "M") {
    params.mx = x;
    params.my = y;
    params.x = x;
    params.y = y;
    return segment;
  } else if (pathCommand === "A") {
    return ["C" as string | number].concat(
      arcToCubic(
        px1,
        py1,
        values[0],
        values[1],
        values[2],
        values[3],
        values[4],
        values[5],
        values[6],
      ),
    ) as CSegment;
  } else if (pathCommand === "Q") {
    params.qx = x;
    params.qy = y;
    return ["C" as string | number].concat(
      quadToCubic(px1, py1, values[0], values[1], values[2], values[3]),
    ) as CSegment;
  } else if (pathCommand === "L") {
    return ["C" as string | number].concat(
      lineToCubic(px1, py1, x, y),
    ) as CSegment;
  } else if (pathCommand === "Z") {
    return ["C" as string | number].concat(
      lineToCubic(px1, py1, params.mx, params.my),
    ) as CSegment;
  }

  return segment as MSegment | CSegment;
};
